import base_config from "./base_config";

const prod_config = {
  ...base_config,
  STAGE: "prod",
  ACCOUNT: "966433002334",
  AUTH_PROVIDER: 'AmazonFederate',  // Migrated LASSO -> IdPrism (Phase II, P504206896)
  // Amplify config for cognito - use getter to ensure runtime evaluation
  get AMPLIFY_CONFIG(): any {
    return {
      aws_project_region: base_config.REGION,
      aws_cognito_region: base_config.REGION,
      aws_user_pools_id: "us-west-2_NmvuSmalw",
      aws_user_pools_web_client_id: "4qgb972hgdaq8ugqgfdr0tqrid",
      oauth: {
        domain: "msaservice-prod.auth.us-west-2.amazoncognito.com",
        scope: base_config.TOKEN_SCOPES_ARRAY,
        redirectSignIn: base_config.CALL_BACK_URL,
        redirectSignOut: 'https://goh.lab126.amazon.dev/',
        responseType: base_config.OAUTH_RESPONSE_TYPE,
      },
    };
  },

  // API Gateway Base URL
  BASE_URL: "https://api.msa.lab126.amazon.dev",
};

export default prod_config;
